import { Card, Grid, Stack, Title } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';

import { trpc } from '../../../../../services/trpc';
import { ConstructionSiteReportSection } from '../poseur/-construction-site-report-section';
import { ConstructionSiteReviewSection } from './-components/construction-site-review-section';
import { DeliveryOrderSection } from './-components/delivery-order-section';
import { QuoteSection } from './-components/quote-section';
import { ServiceOrderRequestSection } from './-components/service-order-request-section';
import { TechnicalPlanSection } from './-components/technical-plan-section';

export const Route = createFileRoute('/app/projets/$slug/documents/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();

  const { data: project } = trpc.projects.get.useQuery({
    slug,
  });

  // console.log(project);

  if (!project) return null;

  return (
    <Stack>
      <Grid gutter="xl">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Stack gap="xl" style={{ minWidth: '280px' }}>
            <Stack>
              <Title order={3}>Marché</Title>
              <Card>
                <QuoteSection project={project} />
              </Card>
            </Stack>
            <Stack>
              <Title order={3}>Plan technique</Title>
              <Card>
                <TechnicalPlanSection project={project} />
              </Card>
            </Stack>
          </Stack>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Stack gap="xl" style={{ minWidth: '280px' }}>
            <Stack>
              <Title order={3}>Compte-rendu de chantier</Title>
              <Card>
                <ConstructionSiteReviewSection project={project} />
              </Card>
            </Stack>
            <Stack>
              <Title order={3}>Ordre de livraison</Title>
              <Card>
                <DeliveryOrderSection project={project} />
              </Card>
            </Stack>
            <Stack>
              <Title order={3}>PV de chantier</Title>
              <Card>
                <ConstructionSiteReportSection project={project} />
              </Card>
            </Stack>
            <Stack>
              <Title order={3}>Fiche d'intervention</Title>
              <Card>
                <ServiceOrderRequestSection project={project} />
              </Card>
            </Stack>
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
